import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptPayload } from '../utils/encryption';

function BulkUploadAuthorization() {
  const navigate = useNavigate();

  const [authSuccess, setAuthSuccess] = useState(false);
  const [authData, setAuthData] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  // const [errorMsg, setErrorMsg] = useState('');

  // console.log('authSuccess',authSuccess);

  useEffect(() => {
    if (!window.location.search) return;

    const hash = window.location.search.substring(1);
    const params = new URLSearchParams(hash);

    const institution = params.get('institution');
    const consent_id  = params.get('consentid');
    const user_uuid = params.get('user-uuid');
    const application_user_id = params.get('application-user-id');
    const consent = params.get('consent');

    // console.log('institution',institution);
    // console.log('consentid',consent_id);
    // console.log('user_uuid',user_uuid);
    // console.log('application_user_id',application_user_id);
    // console.log('consent',consent);


    if (institution && consent_id) {
      setAuthSuccess(true);
      setAuthData({ institution, consent_id, user_uuid, application_user_id, consent });

      // 🔁 Clean URL
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );
    }
  }, []);

  const handleSubmitPayment = async () => {
    if (!authData) return;

    setSubmitting(true);
    // console.log("Sending consent_id:", authData.consent_id);
    // console.log("Sending consent:", authData.consent);
    // setErrorMsg('');

    try {
      const response = await axios.post(
        `${Constants.REPORTS_BASE_URL}volt/bulk-submit`,
        {
          institution: authData.institution,
          consent_id: authData.consent_id,
          user_uuid: authData.user_uuid,
          application_user_id: authData.application_user_id,
          consent: authData.consent,
        },
        {
          auth: {
            username: Constants.REPORTS_USER_NAME,
            password: Constants.REPORTS_PASSWORD,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('login_token')),
            // fx_key: Constants.SUBSCRIPTION_KEY,
          }
        }
      );
      // console.log('response', response);


      if (response.status === 200) {

        const token = sessionStorage.getItem('login_token');
        const uniqueId = sessionStorage.getItem('bulk_unique_id');
        const totalRecords = sessionStorage.getItem('totalRecords');
        const totalPayment = sessionStorage.getItem('totalPayment');
        const fileName = sessionStorage.getItem('fileName');
        // console.log('uniqueId', uniqueId);
        // console.log('totalRecords', totalRecords);
        // console.log('totalPayment', totalPayment);
        // console.log('fileName', fileName);
        const encryptedPayload = await encryptPayload({
            uniqueId,
            fileName,
            totalRecords,
            totalPayment,
            platform: 'web',
            extraParamValidation: 'trustedfromweb'
          });
        const resp = await axios.post(
          Constants.BASE_URL + 'API-FX-212-BULK-UPLOAD-CONFIRM',
          encryptedPayload,
          {
            headers: {
              Authorization: 'Bearer ' + JSON.parse(token),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          }
        );

        // console.log('resp', resp);

        if (Number(resp.data.status) === 200) {
          toast.success('Authorization Completed Successfully');
          console.log(resp.data.message);
          setTimeout(() => {
            navigate('/BulkUpload');
          }, 2000);
        } else {
          toast.error(resp.data.message);
        }




      }
    } catch (error) {
      // console.error('');
      const errorMsg =
        error.response?.data?.data?.error?.message ||
        error.response?.data?.message ||
        "Authorization failed. Please try again.";

      toast.error(errorMsg);

    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white w-full max-w-xl rounded-2xl shadow-lg p-8 text-center">
        <ToastContainer />

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div
            className={`w-16 h-16 rounded-full flex items-center justify-center
            ${authSuccess ? 'bg-green-100' : 'bg-blue-100'}`}
          >
            {authSuccess ? (
              <svg
                className="w-8 h-8 text-green-600"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg
                className="w-8 h-8 text-blue-600"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 11c0-3.866-3.134-7-7-7m14 0c-3.866 0-7 3.134-7 7m0 0v4m0 4h.01" />
              </svg>
            )}
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {authSuccess ? 'Authorization Successful' : 'Authorise Bulk Payment'}
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-6 leading-relaxed">
          {authSuccess
            ? 'Your bank authorisation was completed successfully. You can now submit the bulk payment.'
            : 'You are about to authorise a bulk payment through your selected bank. Please complete the authorisation securely to proceed.'}
        </p>

        {/* Info box */}
        <div
          className={`rounded-xl p-4 text-sm mb-6
          ${authSuccess ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-700'}`}
        >
          {authSuccess ? (
            <p>✅ Bank authorisation completed successfully</p>
          ) : (
            <>
              <p className="mb-1">
                🔒 <b>Secure Bank Authentication</b>
              </p>
              <p>
                You will be redirected to your bank to approve this transaction.
                Once completed, you’ll return here automatically.
              </p>
            </>
          )}
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {!authSuccess && (
            <>
              <button
                onClick={() => navigate(-1)}
                className="px-6 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
              >
                Go Back
              </button>

              <button
                onClick={() => {
                  // window.location.href = authUrl;
                }}
                className="px-6 py-2 rounded-xl bg-[#0B214E] text-white hover:bg-[#081a3a] transition"
              >
                Continue to Bank
              </button>
            </>
          )}

          {/* {errorMsg && (
            <div className="mb-4 text-sm text-red-600 bg-red-50 p-3 rounded-lg">
              {errorMsg}
            </div>
          )} */}


          {authSuccess && (
            <button
              disabled={submitting}
              onClick={handleSubmitPayment}
              className="px-6 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700 transition"
            >
              {submitting ? 'Submitting...' : 'Submit Payment'}
            </button>
          )}
        </div>

        {/* Footer note */}
        <p className="mt-6 text-xs text-gray-400">
          Do not refresh or close this page during authorisation.
        </p>
      </div>
    </div>
  );
}

export default BulkUploadAuthorization;